<template>
  <div class="testimonial-card">
    <div class="card-wrapper" style="height: 100%">
      <div class="display-picture">
        <img src="https://placeimg.com/80/80/people" alt srcset />
      </div>
      <div class="heading">
        <span class="quote">
          <img src="/img/icons/png/quote-icon.png" alt="" srcset="" />
        </span>
        {{ review.review_title }}
      </div>
      <p class="review" :class="!readMore ? 'show' : ''">
        {{ review.review_text }}
      </p>
      <div class="bottom">
        <span
          @click="readMore = !readMore"
          v-if="readMore && review.review_text.length > 64"
          >read more</span
        >
        <span
          @click="readMore = !readMore"
          v-if="!readMore && review.review_text.length > 64"
          >read less</span
        >
        <div class="seperator"></div>
        <div class="details">
          <p class="name mb-0">{{ review.user_name }}</p>
          <!--<span>-->
          <!--{{ testimonialdata[0].designitaion }},-->
          <!--{{ testimonialdata[0].place }}-->
          <!--</span>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TestimonialCard",
  data() {
    return {
      reviewText: "",
      readMore: true
    };
  },
  props: {
    review: Object
  },
  mounted() {}
};
</script>
